import { observer } from 'mobx-react';

import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerPanel,
  DrawerTrigger,
} from '../../../../../app/shared/components/Drawer/Drawer';
import Icon from '../../../../../app/shared/components/Icon/Icon';
import StoreFlag from '../../../StoreFlag';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import StoreAndLanguageSelectorState from '../StoreAndLanguageSelectorState';
import StoreSelector from '../StoreSelector/StoreSelector';
import css from './StoreAndLanguageSelectorDrawer.css';

interface StoreAndLanguageSelectorProps {
  state: StoreAndLanguageSelectorState;
}

function StoreAndLanguageSelector({ state }: StoreAndLanguageSelectorProps) {
  return (
    <Drawer>
      <DrawerTrigger
        className={css.trigger}
        aria-label={state.translation.openButton.interpolate([
          ['currentStore', state.currentStore.displayName],
          ['currentLanguage', state.currentLanguage.displayName],
        ])}
      >
        <StoreFlag className={css.flag} storeId={state.currentStore.id} />
        <span className={css.text} aria-hidden="true">
          <span>{state.currentStore.countryCode}</span>|<span>{state.currentLanguage.code}</span>
        </span>
        <Icon className={css.icon} name="angleDown" />
      </DrawerTrigger>
      <DrawerPanel closeButtonLabel={state.translation.closeButton}>
        <DrawerHeader>{state.translation.title}</DrawerHeader>
        <DrawerContent className={css.content}>
          <LanguageSelector
            items={state.currentStoreLanguages}
            selectedItem={state.currentLanguage}
            translation={state.translation.languageSelector}
            onSelect={state.selectLanguage}
          />
          <StoreSelector
            currentStoreKey={state.currentStore.key}
            items={state.stores}
            translation={state.translation.storeSelector}
            onSelect={state.selectStore}
          />
        </DrawerContent>
      </DrawerPanel>
    </Drawer>
  );
}

export default observer(StoreAndLanguageSelector);
